import React from 'react'
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Carousel } from 'react-responsive-carousel';
import axios from 'axios';

const Video = (props) => {
    const [data, setData] = React.useState([{
        video: "",
        video2: "",
        video3: "",
    }]);
    const colorString = Object.values(props.theme).toString();
    React.useEffect(() => {
        axios.get('https://appi.colexion.io/api/Videos').then(resp => {
            setData(resp.data);
            console.log(resp.data);
        });
    }, [])
    return (
        <section className={colorString === 'true'?`homeVideoSec dark`: `homeVideoSec whiteTheme`}>
            {console.log(data)}
            <div className="container">
                <div className="homeVideo">
                    <Carousel autoPlay={false} showArrows={true} showThumbs={false} showStatus={false} showIndicators={false} dynamicHeight={true}>
                        {!!data[0].video && 
                            <div className="videoBx">
                                <iframe width="100%" height="600" src={data[0].video} title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>
                            </div>
                        }
                        {!!data[0].video2 && 
                            <div className="videoBx">
                                <iframe width="100%" height="600" src={data[0].video2} title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>
                            </div>
                        }
                        {!!data[0].video3 && 
                            <div className="videoBx">
                                <iframe width="100%" height="600" src={data[0].video3} title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>
                            </div>
                        }
                    </Carousel>
                </div>
            </div>
        </section>
    )
}
export default Video;